import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useEffect, useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import CategoryModalContent from "./ModalContent/CategoryModalContent";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useCategoryParentID, useGetProduct } from "./useProduct";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useGetOrgUnitsData } from "../Employee/hooks/useEmployee";
import {Spinner} from'reactstrap'
import { downloadExcelGet } from "../../utils/ExcelDownload";
type Props = {};

const ImageCell = ({ photo, handleTableImage, BASE_URL }: any) => {
  const [loading, setLoading] = useState(true);

  const imgSrc = photo ? `${BASE_URL}${photo}` : "https://via.placeholder.com/100?text=No+Image";

  return (
    <>
      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner color="success" style={{color:'green', width: "2rem", height: "2rem" }} />
        </div>
      )}

      <img
        src={imgSrc}
        alt="avatar"
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          cursor: "pointer",
          display: loading ? "none" : "inline-block",
        }}
        onClick={() => handleTableImage(imgSrc)}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)} // also hide spinner if image fails
      />
    </>
  );
};

const HeaderContent = (props: any) => {
  const handleFilter = (key: any, selected: any) => {
    props?.setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null :(selected.id),
    }));

  };

  return (
    <div
      style={{
        marginBottom: "15px",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <RoundedDropdown
        options={props?.orgUnitsList || []}
        onSelect={(e) => handleFilter(props.handleFilterObjectKey, e)}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading={props?.DropdownHeading}
        headingColor="#2e8dd3"
      />
    </div>
  );
};

const Categories = (props: Props) => {
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<"add" | "edit" | "">("");

  const [filterData, setFilterData] = useState<any>({
    page: 1, 
    limit: 10,
    orgUnit:null,
    CategoryID:null
    });

  const [searchTime, setSeachTime] = useState<string>("");
  const [APIsearch, setAPISearch] = useState("");
  const [ID, setID] = useState<number | undefined>();

  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [disabled,setDisabled] = useState<boolean>(false);     
  

const categoryDataColumns = (
   handleEditCategory: (row: any) => void,
   handleTableImage: (row: any) => void
)=> [
{
  name: "Image",
  cell: (row: any) => (
    <ImageCell
      photo={row.photo}
      handleTableImage={handleTableImage}
      BASE_URL={BASE_URL}
    />
  ),
},
  {
    name: "Org Unit Name",
    selector: (row: { orgname: number | string }) => row.orgname,
    sortable: true,
    width:'160px'
  },
  {
    name:"Name",
    selector: (row: { name: string }) => row.name,
    sortable: true,
    wrap:true
  },
  {
    name: "Type",
    selector: (row: { type: string }) => row.type,
    sortable: true,
  },
  {
    name: "Description",
    selector: (row: { description: string }) => row.description,
    sortable: true,
    wrap:true,
    width:'180px'
  },
  {
    name: "Created At",
    selector: (row: { created: string }) => row.created,
    sortable: true,
    wrap:true,
    width:'180px'    
  },
  {
    name: "Modified At",
    selector: (row: { modified: string }) => row.modified || '-',
    sortable: true,
    wrap:true,
    width:'180px'


  },
  {
    name: "Action",

    cell: (row: any) => (
      <button
        onClick={() => handleEditCategory(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "80px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];
  /// API
  const {data:CategoryParentId} = useCategoryParentID({enable:true})
  const { data, isLoading, isSuccess } = useGetProduct({
    enable: true,
    params: {
      parentCategoryId:filterData.CategoryID ==="All" ?null :filterData.CategoryID,
      orgUnitId:filterData.orgUnit,
      ...(APIsearch == "" ?{}:{search: APIsearch}),
      page: filterData.page,  
      limit: filterData.limit,
    },
  });

  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
 
  const categoryData = Array.isArray(data?.data?.data)
  ? data.data.data.map((item: any) => {
   
      const CreatedAt = item?.CreatedAt?.split(" ")[0] || "";
      const UpdatedAt = item?.UpdatedAt?.split(" ")[0] || "";
      return {
        id: item?.Id,
        photo: item?.CategoryMedia || '-',
        orgname: item?.OrgUnit.UnitName|| "-",
        name: item?.CategoryName || "-",
        type: item?.CategoryType || "-",
        description: item?.CategoryDescription || "-",
        CategoryDisplayOrder: item?.CategoryDisplayOrder || 0,
        created: CreatedAt,
        modified: UpdatedAt,
      };
    })
  : [];


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTime.trim() !== "") {
        setAPISearch(searchTime);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTime]);

  const formatedCategoryParentData = [
  { id:'All', label: 'All' },
  ...Object.entries(CategoryParentId?.data?.CategoryParentId || {}).map(
    (item:any, label:any) => ({
      id:item[0],
      label:item[1],
    })
  ),
];
 
  const toggleModal = () => {
    setMode("add");
    setIsModalOpen(!isModalOpen);
  };

  const handleClose = () => setIsModalOpen(false);
  const handleEditCategory = (row: any) => {
    setMode("edit");
    setID(row.id);
    setIsModalOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };

  const handleChangeRowPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
      limit: limit,
    }));
  };

  const handleTableImage = (imagePath: any) => {
  setSelectedImage(imagePath);
  setIsImageModalOpen(true);
};

const closeModal = () => {
  setIsImageModalOpen(false);
  setSelectedImage(null);
};

const handleExcelDownload = async(filetype:string)=>{
    const appToken = localStorage.getItem('Apptoke') ||'';
    const params:Record<string,any>={
         ...(filterData.orgUnit === null ?{}:{orgUnitId:filterData.orgUnit}),
         ...(filterData.CategoryID === null?{}:{parentCategoryId:filterData.CategoryID}),
         ...(APIsearch ===""?{}:{search:APIsearch})
    } 
    const queryString = new URLSearchParams(params).toString();
    const apiEndpoint = `${BASE_URL}admin/api/getCategoriesExcel?${queryString}`;
    const fileName = 'productCategory.xlsx';

    try{
      setDisabled(true);
      const response = await downloadExcelGet({apiEndpoint,appToken,fileName})
      
      if(response.success){
         setDisabled(false); 
        }
    }catch(error:any){
      console.log('Error while download Product category excel');
    }finally{
      setDisabled(false);
    }
}

  return (
    <div className="p-2">
      <PageHeader
        title="Categories"
        buttons={[
          {
            label: "+ Add Category",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () =>handleExcelDownload('excel'),
            color:disabled? "#888":"#43B9B2",
            disable:disabled
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Category list"
        dynamicHeightOnRowsPerPage={true}
        data={categoryData}
        columns={categoryDataColumns(handleEditCategory,handleTableImage)}
        handleSearch={(e: any) => setSeachTime(e)}
         showSpinner={isLoading}
        paginationTotalRows={data?.data?.pagination?.total_records}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(limit: any, pageNo: any) => {
          handleChangeRowPerPage(limit, pageNo);
        }}
        
        headerContent={
         <>
         <HeaderContent
         orgUnitsList={orgUnitsList?.data} 
         setFiltersState={setFilterData}
         DropdownHeading="Org Unit"
         handleFilterObjectKey ="orgUnit"
         />
         
         <HeaderContent
         orgUnitsList={formatedCategoryParentData ||[]} // repace this data with category Id.
         setFiltersState={setFilterData}
         DropdownHeading="Category"
         handleFilterObjectKey ="CategoryID"
         />
         </>

        }
      />
      {isImageModalOpen && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,  
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    }}
    onClick={closeModal}
  >
    <img
      src={selectedImage || ""}
      alt="Selected"
      style={{
        width:'300px',
        height: "300px",
        borderRadius: "12px",
        backgroundColor: "#fff",
        padding: 10,
      }}
    />
  </div>
)}
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={mode ==="add" ?'Add Category' : "Edit Category"}
        size="md"
        content={
          <CategoryModalContent mode={mode} handleClose={handleClose} id={ID} />
        }
      />
    </div>
  );
};

export default Categories;
